// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { MathUtils } from "../MathUtils.js";

export let PriceFormatter = function () { };

PriceFormatter.NumberFormatters = {}

PriceFormatter.getNumberFormatter = function (point) 
{
    if (!PriceFormatter.NumberFormatters[point])
    PriceFormatter.NumberFormatters[point] = new Intl.NumberFormat(undefined, {
            minimumFractionDigits: point,
            maximumFractionDigits: point
        })

    return PriceFormatter.NumberFormatters[point]
}

PriceFormatter.formatPrice = function (price, point, withRounding)
{
    if (isNaN(price))
        price = 0

    if (!withRounding)
        price = MathUtils.TruncateDouble(price, point)         // для предотвращения округления в форматере

    let formatter = PriceFormatter.getNumberFormatter(point)

    return formatter.format(price)
}